import { formatCustomDataObject } from '../yesplan_classes/YPCustomDataElementObjects';

const isCustomDataForDefinition = (definition, value) => {
  if (definition.children) return value.children && definition.name === value.name;
  /* Explicitly check if the value is not a group, because atm of writing groups and elements can share keywords */
  if (definition.type) return !value.children && value.keyword === definition.keyword;
  return false;
};

const navigateCustomDataDefinitionsAndValues = (
  definition,
  value,
  parentCallback,
  leafCallback,
  path
) => {
  if (definition.groups) {
    definition.groups.forEach((child) => {
      const childValue = value.groups.find((el) => isCustomDataForDefinition(child, el));
      if (childValue) {
        navigateCustomDataDefinitionsAndValues(
          child,
          childValue,
          parentCallback,
          leafCallback,
          path
        );
      }
    });
  } else if (definition.children) {
    parentCallback(definition, value);
    definition.children.forEach((child) => {
      const { children, ...valueWithoutChildren } = value;
      const childValue = children.find((el) => isCustomDataForDefinition(child, el));
      if (childValue) {
        navigateCustomDataDefinitionsAndValues(
          child,
          childValue,
          parentCallback,
          leafCallback,
          [...path, valueWithoutChildren]
        );
      }
    });
  } else {
    leafCallback(definition, value, path);
  }
};

/* Makes a structure that maps:
  tabId -> list of custom data groups.
  Each custom data group in this structure has a property childrenPerTab, including groups and/or custom data leaf elements
*/

export const customDataPerTab = (
  customDataDefinitions,
  customData,
  groupElementCallback,
  leafElementCallback,
  dateAndTimeFormatSettings
) => {
  const tabs = {};
  const addCustomDataLeafElementToTabStructure = (tab, leafElement, path) => {
    if (!tabs[tab.tabid]) tabs[tab.tabid] = [];
    if (path.length === 0) {
      const previousValuesForTab = tabs[tab.tabid];
      previousValuesForTab.push({ ...leafElement, path });
    } else {
      const parentCD = path[0];
      const parentKeyword = parentCD.keyword;
      const isParentAlreadyAdded = tabs[tab.tabid].find(
        (cd) => cd.keyword === parentKeyword
      );
      let parentInTabStructure = isParentAlreadyAdded || {
        ...parentCD,
        childrenPerTab: []
      };
      if (!isParentAlreadyAdded) tabs[tab.tabid].push(parentInTabStructure);
      path.slice(1).forEach((pathElement) => {
        let childInTabStructure = parentInTabStructure.childrenPerTab.find(
          (child) => child.keyword === pathElement.keyword
        );
        if (!childInTabStructure) {
          childInTabStructure = { ...pathElement, childrenPerTab: [] };
          parentInTabStructure.childrenPerTab.push(childInTabStructure);
        }
        parentInTabStructure = childInTabStructure;
      });
      parentInTabStructure.childrenPerTab.push(leafElement);
    }
  };
  navigateCustomDataDefinitionsAndValues(
    customDataDefinitions,
    customData,
    groupElementCallback,
    (leafDefinition, leafCD, path) => {
      const cdObject = fromJSONToCustomDataObject(leafCD, dateAndTimeFormatSettings);
      if (cdObject !== null) {
        leafElementCallback(leafDefinition, cdObject, path);
        leafDefinition.tabs.forEach((tab) => {
          addCustomDataLeafElementToTabStructure(tab, cdObject, path);
        });
      }
    },
    []
  );
  return tabs;
};

export const processCustomDataForEventWidget = (
  customDataDefinitions,
  customData,
  dateAndTimeFormatSettings
) => {
  const contactBookingObjects = [];
  const tabs = customDataPerTab(
    customDataDefinitions,
    customData,
    () => {},
    (leafDefinition, cdObject) => {
      if (
        cdObject &&
        !cdObject.hasEmptyValue() &&
        cdObject.getTypeForRenderingAsReadOnly() === 'contact'
      ) {
        contactBookingObjects.push(cdObject.booking);
      }
    },
    dateAndTimeFormatSettings
  );
  return {
    customDataPerTab: tabs,
    contactBookingObjects
  };
};

export const setContactCustomData = (
  customDataPerTabData,
  contactReferences,
  contactLinkReferenes
) => {
  Object.values(customDataPerTabData).forEach((collectionOfCustomData) => {
    const doForCustomData = (cdGroupOrLeaf) => {
      if (cdGroupOrLeaf.childrenPerTab)
        cdGroupOrLeaf.childrenPerTab.forEach((child) => doForCustomData(child));
      else if (cdGroupOrLeaf.type.toUpperCase() === 'CONTACTBOOKING')
        cdGroupOrLeaf.setContactReference({
          contacts: contactReferences,
          contactLinks: contactLinkReferenes
        });
    };
    collectionOfCustomData.forEach((cdGroupOrLeaf) => {
      doForCustomData(cdGroupOrLeaf);
    });
  });
};

export const fromJSONToCustomDataObject = formatCustomDataObject;
